import { employeeApi } from 'Api/employee';
import Buttons from 'components/Global/Buttons';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toastText } from 'utils/utils';
import MasterDeductionModal from './MasterDeductionBody';
import styles from './index.module.scss';

const MasterDeductionTab = (props: any) => {
	const {
		employeeId,
		activeTab,
		isUSD,
	} = props;
	const [earningsAmount, setEarningsAmount] = useState<number>(0);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [saveLoading, setSaveLoading] = useState<boolean>(false);

	const { baseCurrencySymbol, usdCurrencySymbol } = useSelector(
		(state: any) => state.userProfile.data
	);


	const masterDeductionButtons = [
		{
			text: 'Save',
			isLoading: saveLoading,
			className: 'btn-blue',
			fontSize: '1.8rem',
			disabled: false,
			minWidth: '12rem',
			minHeight: '4rem',
			isSubmit: true,
			onclick: () => {
				handleMasterDeductions();
			},
		},
	];

	const [data, setData] = useState<any>();

	const handleDataChange = (data: any) => {
		setData(data);
		const total = data?.reduce(
			(sum: any, item: any) =>
				item.isChecked ? sum + parseFloat(item?.amount || '0.00') : sum,
			0
		);
		setEarningsAmount(total);
	};

	const handleMasterDeductions = async () => {
		const finalData = {
			employeeId,
			data,
		};

		try {
			setSaveLoading(true);
			const apiCall = await employeeApi.createEmployeeMasterDeductions(
				finalData
			);

			const message =
				apiCall?.data?.message || 'Master Deductions saved successfully';
			const isSentForApproval =
				message?.toLowerCase().includes('approval') ?? false;
			toastText(
				isSentForApproval ? 'Changes sent for approval' : message,
				'success'
			);
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				`something went wrong failed to save earnings`;
			toastText(message, 'error');
		} finally {
			setSaveLoading(false);
		}
	};


	const fetchMasterDeductions = async () => {
		setIsLoading(true);
		try {
			const res = await employeeApi.getEmployeeMasterDeductions({
				employeeId,
			});

			if (res?.data?.data?.length > 0) {
				setData(res.data.data);
			}
		} catch (error: any) {
			toastText(
				error?.response?.data?.message ||
					'Something went wrong in fetching employee earnings',
				'error'
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div>
			<div className={styles.deductionContainer}>
				<div className={styles.headerBox}>
					<div className={styles.headerContent}>
						<div className={styles.titleContainer}>
							<div className={styles.titleEarnings}>
								Total Deductions
							</div>
							<div className={styles.separation}></div>

							<div className={styles.earningsAmount}>
								{isUSD ? usdCurrencySymbol : baseCurrencySymbol}
								{!isLoading && earningsAmount?.toFixed(2)}
							</div>
							{/* </div> */}
						</div>
						
					</div>
				</div>

				<MasterDeductionModal
					onDataChange={(data) => handleDataChange(data)}
					activeTab={activeTab}
					isUSD={isUSD}
					isLoading={isLoading}
					data={data}
					setData={setData}
					fetchMasterDeductions={fetchMasterDeductions}
				/>
				<div className={styles.buttons}>
					{!isLoading && <Buttons buttons={masterDeductionButtons} />}
				</div>
			</div>
		</div>
	);
};

export default MasterDeductionTab;
